import axios from 'axios';
import apiConfig from '../config/apiConfig';

const API_BASE_URL = apiConfig.BASE_URL;

export const createAdEventId = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}_${Math.random().toString(36).slice(2)}_${Math.random().toString(36).slice(2)}`;
};

/**
 * Get active ads for a placement
 * @param {String} placement - Ad placement (header, sidebar, footer, etc.)
 * @param {String} region - Region code (US, GB, FR, etc.)
 * @param {String} language - Language code (en, fr, es, etc.)
 * @param {String} categoryId - Optional category ID for targeting
 * @param {Number} limit - Maximum number of ads to return (default: 5)
 * @returns {Promise<Object>} Response with ads array
 */
export const getActiveAds = async (placement, params = {}) => {
  try {
    const { region, language, category, limit = 5 } = params;
    
    const queryParams = new URLSearchParams();
    queryParams.append('placement', placement);
    if (region) queryParams.append('region', region);
    if (language) queryParams.append('language', language);
    if (category) queryParams.append('category', category);
    if (limit) queryParams.append('limit', limit);
    
    const response = await axios.get(`${API_BASE_URL}/ads?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching ads:', error);
    // Return empty array on error so ads don't break the page
    return { success: false, data: [], count: 0 };
  }
};

/**
 * Track ad impression
 * @param {String} adId - Ad ID
 * @returns {Promise<void>}
 */
export const trackImpression = async (adId, metadata = {}) => {
  try {
    await axios.post(`${API_BASE_URL}/ads/${adId}/impression`, metadata);
  } catch (error) {
    // Silently fail - tracking shouldn't break the app
    console.error('Error tracking impression:', error);
  }
};

/**
 * Track ad click
 * @param {String} adId - Ad ID
 * @returns {Promise<void>}
 */
export const trackClick = async (adId, metadata = {}) => {
  try {
    await axios.post(`${API_BASE_URL}/ads/${adId}/click`, metadata);
  } catch (error) {
    // Silently fail - tracking shouldn't break the app
    console.error('Error tracking click:', error);
  }
};

export const trackDismissal = async (adId, metadata = {}) => {
  try {
    await axios.post(`${API_BASE_URL}/ads/${adId}/dismissal`, metadata);
  } catch (error) {
    console.error('Error tracking ad dismissal:', error);
  }
};
